import React from "react";
import { Badge } from "./ConnectorStatusBadge.styles";
import type {
  ConnectorConnectionStatus,
  ConnectorStatusBadgeProps,
} from "./ConnectorStatusBadge.types";

const DEFAULT_LABELS: Record<ConnectorConnectionStatus, string> = {
  connected: "Connected",
  disconnected: "Disconnected",
  error: "Error",
  not_connected: "Not connected",
};

export const ConnectorStatusBadge: React.FC<ConnectorStatusBadgeProps> = ({
  status,
  label,
  className,
}) => (
  <Badge $status={status} className={className} role="status">
    {label ?? DEFAULT_LABELS[status]}
  </Badge>
);

export default ConnectorStatusBadge;
